module.exports = __webpack_public_path__ + "img/banner-btk.0a4c4380.png";